// animation
import { Fade, Slide } from "react-awesome-reveal";

const StepOne = ({
  emotionsData,
  formData,
  setFormData,
  setActiveStep,
  isLoading,
}) => {
  // check emotion is already selected or not
  const checkSelectedEmotion = (id) => {
    let available = formData?.emotions?.find((emotion) => emotion === id);
    if (available) return true;
    return false;
  };

  // select a emotion
  const toggleEmotionSelect = (id) => {
    let newData = [];
    let checkItem = checkSelectedEmotion(id);
    if (checkItem) {
      newData = formData?.emotions?.filter((v) => v !== id);
    } else {
      newData = [...formData?.emotions, id];
    }
    setFormData({
      ...formData,
      emotions: newData,
    });
  };

  return (
    <>
      <Fade triggerOnce delay={100} duration={1000}>
        <h3>
          What are you <br /> struggling with most?
        </h3>
      </Fade>
      <div className={`step_card_body w_100 emotions_wrapper`}>
        {isLoading ? (
          <p className="mx_auto w_100 text_center">
            <br /> <br />
            Loading...
            <br />
          </p>
        ) : emotionsData && emotionsData?.length > 0 ? (
          emotionsData?.map((item, index) => (
            <div
              key={index}
              role="button"
              onClick={() => toggleEmotionSelect(item?._id)}
              className={`emotionBox ${
                checkSelectedEmotion(item?._id) ? " selected" : " "
              }`}
            >
              <div className="emotion_img">
                <img src={item?.media?.image?.url} alt="" />
              </div>

              <h4>{item?.title}</h4>
            </div>
          ))
        ) : (
          "Something went wrong! no data fetched."
        )}
      </div>
      <div className="mt_auto screen_sticky_footer">
        <Fade triggerOnce delay={200} duration={1300}>
          <button
            disabled={!formData?.emotions?.length > 0}
            onClick={() => setActiveStep(1)}
            className="cs_btn w_100"
          >
            Continue
          </button>
        </Fade>
      </div>
    </>
  );
};
export default StepOne;
